import * as actionTypes from './action-types'

export const fetchVendors = ({ page, keyword, filters } = {}) => ({
  type: actionTypes.FETCH_VENDORS,
  payload: { page, keyword, filters },
})

export const selectVendor = id => ({
  type: actionTypes.SELECT_VENDOR,
  payload: { id },
})

export const selectAll = () => ({
  type: actionTypes.SELECT_ALL,
})

export const resetSelected = () => ({
  type: actionTypes.RESET_SELECTED_ON_PAGE,
})

export const addVendor = data => ({
  type: actionTypes.ADD_VENDOR,
  payload: data,
})

export const addVendorClear = () => ({
  type: actionTypes.ADD_VENDOR_CLEAR,
})

export const confirmAddVendorFake = () => ({
  type: actionTypes.CONFIRM_ADD_VENDOR_FAKE,
})

export const fetchSearchOptions = (keyword, filters) => ({
  type: actionTypes.GET_SEARCH_OPTIONS,
  payload: { keyword, filters },
})

export const clearSearchOptions = () => ({
  type: actionTypes.CLEAR_SEARCH_OPTIONS,
})

export const removeVendors = (ids, filters) => ({
  type: actionTypes.REMOVE,
  payload: { ids, filters },
})

export const fakeRemoveVendors = (ids, filters) => ({
  type: actionTypes.REMOVE_FAKE,
  payload: { ids, filters },
})

export const setSearchFilters = ({ keyword }) => ({
  type: actionTypes.SET_SEARCH_FILTERS,
  payload: { keyword },
})
